import {
  faCalendarAlt,
  faCalendarDays,
  faChevronLeft,
  faChevronRight,
  faCog,
  faEye,
  faEyeSlash,
  faList,
  faLock,
  faLockOpen,
  faPencilAlt,
  faPrint,
  faTag,
  faTags,
  faTimesCircle,
  faTrashAlt,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import React, { useEffect, useRef, useState } from 'react';
import { useCookies, withCookies } from 'react-cookie';
import {
  Button,
  Card,
  CardBody,
  Input,
  InputGroup,
  InputGroupText,
  ModalBody,
  ModalHeader,
  Popover,
  PopoverBody,
  PopoverHeader,
  UncontrolledTooltip,
  UncontrolledPopover,
  Label,
  FormGroup,
} from 'reactstrap';
import Swal from 'sweetalert2';
import { useAuth0 } from '../../../../auth0/reactAuth0Spa';
import { checkLoginForError, formatBearerToken, swalErrorMessage } from '../../../../Common.functions';
import {
  deleteData,
  fetchDataAgnostic,
  fetchDataAuth0,
  postDataAgnostic,
  postDataAgnosticWithoutCredentials,
  putData,
} from '../../../../Services/dataApi';
import { clone } from '../../../../Services/schedule';
import PrintDropDown from '../../Coordinator/Schedule/TopBar/PrintDropDown/index';
import PrintDropDownTotal from '../../Coordinator/Schedule/TopBar/PrintDropDownTotal/index';

import '../AdminLanding.style.css';
import InterviewDatePopover from './InterviewDatePopover/InterviewDatePopover';
// import RegistrationLimitPopover from './RegistrationLimitPopover/RegistrationLimitPopover';
import RegistrationLimitPopover from './RegistrationLimitPopover2/RegistrationLimitPopover';

import style from './style';

import { toast } from 'react-toastify';

import './AdminInterviewDates.style.css';
import LinkSettingsButton from 'Body/RezRATE/Common/LinkSettingsButton/LinkSettingsButton';
import RezRateBanner from 'Body/RezRATE/Common/RezRateBanner/RezRateBanner';
import RezRateTable from 'Body/RezRATE/Common/RezRateTable/RezRateTable';
import LimitInput from './LimitInput/LimitInput';

// Initialize Day.js plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);

const WidgetStyle = {
  maxHeight: '600px',
  maxWidth: '350px',
  padding: '15px',
  border: '1px solid black',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const inputWithUnitWrapper = {
  display: 'flex',
  alignItems: 'center',
  p: {
    paddingLeft: '10px',
  },
};

const getTodayAtEight = () => {
  const rightNow = new Date(Date.now());
  rightNow.setHours(8, 0, 0, 0);
  return rightNow;
};

let typingTimeout = null;
let lastEditedField = null;
const AdminInterviewDates = ({
  dContext,
  token,
  activeDepartment,
  activeSeason,
  currentInterviewDates,
  formatThenSetInterviewDates,
  setSelectedScheduleItem,
  history,
}) => {
  const [tagChoices, setTagChoices] = useState([]);
  const [error, setError] = useState(false);
  const [activeSchedule, setActiveSchedule] = useState(null);
  const [selectableUsers, setSelectableUsers] = useState([]);
  const [inputRef, setInputRef] = useState(null);
  const [openPicker, setOpenPicker] = useState(false);
  const [showSettings, setShowSettings] = useState({});
  const [cookies, setCookies] = useCookies([]);
  const [showPastInterviewDates, setShowPastInterviewDates] = useState(
    cookies.showPastInterviewDates === 'false' ? 'false' : 'true',
  );
  const [filteredInterviewDates, setFilteredInterviewDates] = useState([]);
  const [departmentSettings, setDepartmentSettings] = useState({});
  const [tagFilterHasChanges, setTagFilterHasChanges] = useState(false);
  const [lockBeforeDays, setLockBeforeDays] = useState(0);
  const [isUpdatingLockBeforeDays, setIsUpdatingLockBeforeDays] = useState(false);
  const [lastField, setLastField] = useState();
  const [isCalendarView, setIsCalendarView] = useState(false);
  const [calendarMonth, setCalendarMonth] = useState(dayjs().startOf('month'));
  const [expandedSessionKey, setExpandedSessionKey] = useState(null);

  const typeChangeRef = useRef();
  const monthPickerRef = useRef();
  // Alert functionality replaced with toast

  const createTimeslotEntries = (numberOfRooms, startTime, activeSchedule) => {
    const timeSlotEntries = [];

    const numberOfTimeslots = Number(numberOfRooms) + 2;

    for (let i = 0; i < numberOfTimeslots; i++) {
      timeSlotEntries.push({ fk_InterviewDate: activeSchedule, SortOrder: i });
    }

    return timeSlotEntries;
  };

  const { getTokenSilently, loginWithRedirect } = useAuth0();

  const [today, setToday] = useState(dayjs(new Date(Date.now())));
  const [isUpdating, setIsUpdating] = useState();

  let totalInterviewDates = currentInterviewDates.length;
  let totalRegisteredCandidates = 0;
  let totalCandidateLimit = 0;

  currentInterviewDates.forEach((interviewDate) => {
    if (interviewDate.CountOfCandidates) {
      totalRegisteredCandidates += interviewDate.CountOfCandidates;
    }
    if (interviewDate.CandidateRegistrationLimit) {
      totalCandidateLimit += interviewDate.CandidateRegistrationLimit;
    }
  });

  const handleScheduleClick = (pk_InterviewDate) => {
    setActiveSchedule(pk_InterviewDate);
    getTokenSilently()
      .then(async (token) => {
        try {
          const entry = await fetchDataAuth0(
            'department/InterviewDateById',
            { pk_InterviewDate, pk_Department: activeDepartment.pk_Department },
            formatBearerToken(token),
          );
          if (entry.data && entry.data.Timeslots && entry.data.Timeslots.length > 0) {
            setSelectedScheduleItem(entry.data);
            history.push(`administrator/schedule/${entry.data.pk_InterviewDate}`);
          } else {
          }
        } catch (err) {
          toast.error('Something went wrong, please try again later or contact support.');
        }
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
    // setOpenOptions(true);
  };

  useEffect(() => {
    getActiveInterviewDates();
    // filterInterviewDates();
    if (cookies) {
      setShowPastInterviewDates(cookies.showPastInterviewDates === 'false' ? 'false' : 'true');
    }
    getDepartment();
    getTags();
  }, []);

  useEffect(() => {
    if (openPicker) {
    }
  }, [openPicker]);

  useEffect(() => {
    if (token && dContext) {
      getTags();
    }
  }, [token, dContext]);

  const activeDepartmentId = dContext?.department?.pk_Department || activeDepartment?.pk_Department;
  const activeSeasonId = dContext?.season?.pk_Season || activeSeason?.pk_Season;

  const getAltViewStorageKey = () => {
    return `adminInterviewDates_altView_${activeDepartmentId}_${activeSeasonId}`;
  };

  const persistAltViewPreference = (nextIsCalendarView) => {
    if (!activeDepartmentId || !activeSeasonId) {
      return;
    }

    try {
      localStorage.setItem(getAltViewStorageKey(), nextIsCalendarView ? 'calendar' : 'table');
    } catch (err) {}
  };

  useEffect(() => {
    if (!activeDepartment || !activeSeason) return;

    const { pk_Department } = activeDepartment;
    const { pk_Season } = activeSeason;

    getTokenSilently()
      .then(async (token) => {
        try {
          const departmentUsers = await fetchDataAuth0('user/all', { pk_Department }, formatBearerToken(token));
          setSelectableUsers(departmentUsers.data);
        } catch (err) {
          setError(true);
        }

        try {
          const existingEntries = await fetchDataAuth0(
            'department/entries',
            { pk_Department, pk_Season },
            formatBearerToken(token),
          );
          formatThenSetInterviewDates(existingEntries.data);
        } catch (err) {
          setError(true);
        }
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  }, [activeDepartment, activeSeason]);

  useEffect(() => {
    if (!activeDepartmentId || !activeSeasonId) {
      return;
    }

    try {
      const storedAltView = localStorage.getItem(getAltViewStorageKey());
      if (storedAltView === 'calendar' || storedAltView === 'table') {
        setIsCalendarView(storedAltView === 'calendar');
      }
    } catch (err) {}
  }, [activeDepartmentId, activeSeasonId]);

  useEffect(() => {
    if (currentInterviewDates) {
      filterInterviewDates();
    }
  }, [JSON.stringify(currentInterviewDates), showPastInterviewDates, departmentSettings]);

  useEffect(() => {
    if (currentInterviewDates && lastEditedField) {
    }
  }, [currentInterviewDates]);

  useEffect(() => {
    if (filteredInterviewDates && lastEditedField) {
      if (lastEditedField) {
        const id = lastEditedField;
        const lastField = document.getElementById(id);
        if (lastField) {
          lastField.focus();
          lastField.click();
        }

        lastEditedField = null;
        setLastField(null);
      }
    }
  }, [filteredInterviewDates, JSON.stringify(departmentSettings)]);

  const getActiveInterviewDates = (callback) => {
    getTokenSilently()
      .then((t) => {
        fetchDataAuth0(
          'department/interviewDates',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          formatBearerToken(t),
        )
          .then((res) => {
            formatThenSetInterviewDates(res.data);
            if (callback) {
              callback(true);
            }
          })
          .catch((err) => {
            if (callback) {
              callback(false);
            }
          });
      })
      .catch((err) => {
        if (callback) {
          callback(false);
        }
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const saveDaysToLock = (newLockBeforeDays) => {
    setIsUpdatingLockBeforeDays(true);
    getTokenSilently()
      .then((token) => {
        putData(
          'department/settings',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
          },
          {
            payload: {
              DaysWithinInterviewDateToLockDate: parseInt(newLockBeforeDays),
            },
          },
          formatBearerToken(token),
        )
          .then((res) => {
            getActiveInterviewDates();
            getDepartment();
            setTimeout(() => {
              setIsUpdatingLockBeforeDays(false);
            }, 1000);
          })
          .catch((err) => {
            setTimeout(() => {
              setIsUpdatingLockBeforeDays(false);
            }, 1000);
          });
      })
      .catch((err) => {
        setIsUpdatingLockBeforeDays(false);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getDepartment = () => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/settings',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          formatBearerToken(token),
        )
          .then((res) => {
            setDepartmentSettings(res.data[0]);
            if (res.data && res.data[0]) {
              setLockBeforeDays(res.data[0].DaysWithinInterviewDateToLockDate);
            }
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const filterInterviewDates = () => {
    const todayDate = dayjs().format('MMM DD, YYYY');
    const todayDateToCompare = dayjs(`${todayDate} 23:59`);

    const newFilteredInterviewDates = currentInterviewDates.slice().filter((interviewDate) => {
      const { DateOfInterview, StartTime, Label } = interviewDate;

      const dateInThisTimeZone = dayjs.tz(`${DateOfInterview} 23:59`, departmentSettings.TimeZone).tz(dayjs.tz.guess());

      const dateToCompare = dayjs(`${dateInThisTimeZone.format('MMM DD,  YYYY')} 23:59`);

      const isNotPastDate = dateToCompare.isSameOrAfter(todayDateToCompare, 'day');

      return (
        showPastInterviewDates == 'true' ||
        ((showPastInterviewDates == 'false' || !showPastInterviewDates) &&
          dateToCompare.isSameOrAfter(todayDateToCompare, 'day'))
      );
    });

    newFilteredInterviewDates.push({
      pk_InterviewDate: 'summary_row',
      MomentDateOfInterview: totalInterviewDates,
      CountOfCandidates: totalRegisteredCandidates,
      CandidateRegistrationLimit: totalCandidateLimit,
    });

    setFilteredInterviewDates(newFilteredInterviewDates);
  };

  const updateEntry = (entry, entryId, callback) => {
    // Need to put Tag Filter here. If date has Tag Filter, Tag Filter should be passed ALWAYS, otherwise,
    // back end would strip it.
    setIsUpdating(true);
    getTokenSilently()
      .then((token) => {
        putData(
          'department/interviewDate/putEntry',
          {
            pk_Department: activeDepartment.pk_Department,
            pk_InterviewDate: entryId,
            pk_Season: dContext.season.pk_Season,
          },
          { entry },
          formatBearerToken(token),
        )
          .then((result) => {
            setIsUpdating(false);
            if (result.data.error) {
              swalErrorMessage();
              return;
            }
            getActiveInterviewDates(callback);
            typeChangeRef.current = null;
            lastEditedField = null;
            setLastField(null);
            // formatThenSetInterviewDates(result.data);
          })
          .catch((err) => {
            callback(false);
            lastEditedField = null;
            setLastField(null);
            setIsUpdating(false);
            swalErrorMessage();
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const deleteEntry = (entryId) => {
    setIsUpdating(true);
    getTokenSilently()
      .then((token) => {
        deleteData(
          'department/deleteEntry',
          null,
          { entryId, departmentId: activeDepartment.pk_Department },
          formatBearerToken(token),
        )
          .then((result) => {
            setIsUpdating(false);
            if (result.data.error) {
              swalErrorMessage();
              return;
            }

            toast.success('Interview Date deleted!');

            getActiveInterviewDates();
            //formatThenSetInterviewDates(result.data);
          })
          .catch((err) => {
            setIsUpdating(false);
            swalErrorMessage();
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const addDate = (data) => {
    const { selectedDate, Label = '' } = data;

    setIsUpdating(true);
    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/createEntry',
          null,
          {
            departmentId: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
            entry: { selectedDate, Label: Label },
          },
          formatBearerToken(token),
        )
          .then((result) => {
            setOpenPicker(false);
            setIsUpdating(false);
            if (result.data.error) {
              swalErrorMessage();
              return;
            }
            toast.success('Session Added!');
            getActiveInterviewDates();
            // formatThenSetInterviewDates(result.data);
          })
          .catch((err) => {
            setIsUpdating(false);
            swalErrorMessage();
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getTags = () => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/tags',
          { pk_Department: dContext.department.pk_Department },
          formatBearerToken(token),
        )
          .then((res) => {
            setTagChoices(res.data);
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const setPrintPopoverOpen = (key, shouldOpen) => {
    setShowSettings((prevSettings) => {
      const nextSettings = clone(prevSettings || {});

      Object.keys(nextSettings).forEach((rawKey) => {
        if (rawKey === 'printer_all_btn' || rawKey.indexOf('printer_btn_') === 0) {
          nextSettings[rawKey] = false;
        }
      });

      nextSettings[key] = shouldOpen;
      return nextSettings;
    });
  };

  const headerFormatter = (column, colIndex) => {
    if (colIndex == 0) {
      return <div style={style.headerStyle}>{column.text}</div>;
    }

    return (
      <div style={style.headerStyle} id={`${column.text}`}>
        {`${column.text} `} {renderHeaderTooltip(column)}
        {colIndex == 1 ? (
          <Button
            color="success"
            size="sm"
            style={{ marginLeft: 10 }}
            id={'addInterviewDateBtn'}
            onClick={() => {
              setOpenPicker(!openPicker);
              const newSettings = clone(showSettings);
              Object.keys(newSettings).forEach((key) => {
                newSettings[key] = false;
              });
              setShowSettings(clone(newSettings));
            }}
          >
            Add
          </Button>
        ) : null}
        {colIndex == 1 ? renderHeaderDatePopover() : null}
      </div>
    );
  };

  const renderHeaderTooltip = (column) => {
    switch (column.text) {
      case 'Registered':
        return (
          <UncontrolledTooltip target={`${column.text}`} placement="top">
            Indicates the number of candidates currently registered to interview on a session.
          </UncontrolledTooltip>
        );

      case 'Limit':
        return (
          <UncontrolledTooltip target={`${column.text}`} placement="top">
            Indicates the number of candidates allowed to register for a session.
          </UncontrolledTooltip>
        );

      case 'Waitlisted':
        return (
          <UncontrolledTooltip target={`${column.text}`} placement="top">
            Indicates the number of candidates currently waitlisted for a session
          </UncontrolledTooltip>
        );
      default:
        return null;
    }
  };

  const toggleModal = (key) => {
    // const key = `date_btn_${rowIndex}`;
    const newSettings = clone(showSettings);
    Object.keys(newSettings).forEach((rawKey) => {
      if (rawKey !== key) {
        newSettings[rawKey] = false;
      }
    });
    newSettings[key] = !newSettings[key];
    setShowSettings(newSettings);
  };

  const renderLimitInput = (options) => {
    const { cell, cellData, rowIndex, formatExtraData, renderType = 1 } = options;

    const { pk_InterviewDate, CandidateRegistrationLimit, CountOfCandidates, tags, hiddenParent } = cellData;

    const allowTagFiltering = departmentSettings && departmentSettings.EnableTagFiltering; // get from department settings

    const inputKey = `registration_btn_${pk_InterviewDate}_${hiddenParent ? 'hidden' : 'visible'}`;
    let countToDisplay = CandidateRegistrationLimit;
    if (tags && allowTagFiltering) {
      tags.forEach((tag) => {
        countToDisplay += tag.InterviewDateLimit;
      });
    }

    if (renderType == 1) {
      return (
        <div style={style.cellStyle}>
          <InputGroup>
            <Input
              disabled={isUpdating || (lastField != null && lastField !== inputKey)}
              onFocus={(e) => {
                if (allowTagFiltering) {
                  e.target.blur();
                }
              }}
              id={inputKey}
              key={`key_${inputKey}_${allowTagFiltering ? countToDisplay : cell || 0}`}
              type={allowTagFiltering ? 'text' : 'number'}
              // value={allowTagFiltering ? countToDisplay : cell || 0}
              defaultValue={allowTagFiltering ? countToDisplay : cell || 0}
              style={{
                textAlign: 'center',
                marginRight: allowTagFiltering ? -46 : 0,
                fontSize: 12,
                backgroundColor:
                  countToDisplay == CountOfCandidates || (countToDisplay == null && CountOfCandidates == 0)
                    ? '#88ff82'
                    : CountOfCandidates > countToDisplay
                    ? '#ffc180'
                    : null,
              }}
              onClick={(e) => {
                if (allowTagFiltering) {
                  e.target.blur();
                }

                if (isUpdating) {
                  e.stopPropagation();
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                if (allowTagFiltering || isUpdating) {
                  return;
                }

                if (typingTimeout) {
                  clearTimeout(typingTimeout);
                  typingTimeout = null;
                }
                const newValue = parseInt(e.target.value);

                if (typeChangeRef && typeChangeRef.current) {
                  typeChangeRef.current.CandidateRegistrationLimit = newValue >= 0 ? newValue : 0;
                } else {
                  typeChangeRef.current = { CandidateRegistrationLimit: newValue >= 0 ? newValue : 0 };
                }

                setLastField(inputKey);
                lastEditedField = inputKey; // `registration_btn_${rowIndex}`;
                typingTimeout = setTimeout(() => {
                  updateEntry(typeChangeRef.current, pk_InterviewDate);
                }, 1000);
              }}
            />
            {allowTagFiltering ? (
              <>
                <Button
                  size="sm"
                  id={`registration_btn_${rowIndex}`}
                  style={{ zIndex: 0 }}
                  color="secondary"
                  onClick={() => {
                    const key = `registration_btn_${rowIndex}`;
                    const newSettings = clone(showSettings);
                    newSettings[key] = !newSettings[key];
                    setShowSettings(newSettings);
                  }}
                >
                  <FontAwesomeIcon icon={faTags} />
                </Button>
                {renderRegistrationLimitPopover({ ...cellData, rowIndex, targetId: `registration_btn_${rowIndex}` })}
              </>
            ) : null}
          </InputGroup>
        </div>
      );
    } else if (renderType == 2) {
      return (
        <LimitInput
          {...options}
          departmentSettings={departmentSettings}
          hiddenParent={hiddenParent}
          isUpdating={isUpdating}
          lastField={lastField}
          renderRegistrationLimitPopover={renderRegistrationLimitPopover}
          row={cellData}
          setLastField={setLastField}
          setShowSettings={setShowSettings}
          showSettings={showSettings}
          typeChangeRef={typeChangeRef}
          typingTimeout={typingTimeout}
          updateEntry={updateEntry}
          clearTypeTimeout={() => {
            clearTimeout(typingTimeout);
          }}
        />
      );
    }
  };

  const cellFormatter = (cell, cellData) => {
    // const { row, formatExtraData = {} } = cellData;
    // const { original, index } = row;

    const {
      CandidateRegistrationLimit,
      CannotBeUnlocked,
      column,
      CountOfCandidates,
      DateOfInterview,
      EnableHiddenStatus,
      EnableLockedStatus,
      formatExtraData,
      hiddenParent,
      Label,
      MainRoomURL,
      MainRoomURLDetails,
      MomentDateOfInterview,
      pk_InterviewDate,
      row,
      rowIndex,
      ScheduleBuildingHasBeenStarted,
      StartTime,
    } = cellData;
    const columnId = column.dataKey;

    // Handle summary row
    if (pk_InterviewDate === 'summary_row') {
      let itemToReturn = null;
      switch (columnId) {
        case 'delete_placeholder':
          itemToReturn = (
            <div style={{ ...style.cellStyle, fontSize: 13 }}>
              <b>SEASON TOTAL</b>
            </div>
          );
          // itemToReturn = 'xxx';
          break;
        case 'CandidateRegistrationLimit':
          itemToReturn = (
            <div style={{ ...style.cellStyle, fontWeight: 'bold' }}>
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  history.push(`/administrator/candidates/sendmessages?filterBy=Scheduled`);
                }}
              >
                {cell || 0}
              </div>
            </div>
          );
          break;
        case 'CountOfCandidates':
          itemToReturn = (
            <div style={{ ...style.cellStyle, fontWeight: 'bold' }}>
              <div
                style={{ cursor: 'pointer', color: '#007bff' }}
                onClick={() => {
                  history.push(`/administrator/candidates/sendmessages?filterBy=Scheduled`);
                }}
              >
                {cell ? cell : 0}
              </div>
            </div>
          );
          break;
        case 'settings_placeholder':
          itemToReturn = (
            <div style={{ ...style.cellStyle, fontSize: 13 }}>
              <b style={{ whiteSpace: 'nowrap' }}>
                Lock{' '}
                <Input
                  disabled={isUpdatingLockBeforeDays}
                  id="lockDate"
                  type={'number'}
                  value={lockBeforeDays}
                  style={{
                    fontSize: 12,
                    width: 50,
                    display: 'inline-block',
                    padding: '2px 4px',
                    height: 'auto',
                    marginLeft: 3,
                    marginRight: 3,
                  }}
                  onChange={(e) => {
                    let newValue = parseInt(e.target.value || 0);

                    if (newValue < -1) {
                      newValue = -1;
                    }

                    if (newValue > 99) {
                      newValue = 99;
                    }

                    setLockBeforeDays(newValue);
                    const valueToSave = newValue;
                    lastEditedField = 'lockDate';
                    if (valueToSave != null) {
                      if (typingTimeout) {
                        clearTimeout(typingTimeout);
                      }

                      typingTimeout = setTimeout(() => {
                        saveDaysToLock(valueToSave);
                      }, 1000);
                    }
                  }}
                />
                days before
              </b>
            </div>
          );
          break;

        case 'print_materials_placeholder':
          const printAllKey = 'printer_all_btn';
          itemToReturn = (
            <div style={{ ...style.cellStyle }}>
              <Button
                color="primary"
                size="sm"
                id={printAllKey}
                onClick={() => {
                  setPrintPopoverOpen(printAllKey, !showSettings[printAllKey]);
                }}
              >
                <FontAwesomeIcon icon={faPrint} />
              </Button>
              <UncontrolledTooltip target={printAllKey} placement={'top'}>
                Print All
              </UncontrolledTooltip>
              {renderPrintAllPopover()}
            </div>
          );
          break;

        default:
          itemToReturn = (
            <div style={{ ...style.cellStyle, fontSize: 14 }}>
              <b>{cell}</b>
            </div>
          );
          break;
      }

      return itemToReturn;
    } else {
      const dateInThisTimeZone = dayjs
        .tz(`${DateOfInterview} ${StartTime}`, departmentSettings.TimeZone)
        .tz(dayjs.tz.guess());

      const dateToCompare = dayjs(`${dateInThisTimeZone.format('MMM DD,  YYYY')} 23:59`);

      const isPastInterviewDate = !dateToCompare.isSameOrAfter(today, 'day');

      switch (columnId) {
        case 'delete_placeholder':
          const deleteBtnId = `delete_${pk_InterviewDate}_${hiddenParent ? 'hidden' : 'visible'}`;
          return (
            <div style={{ ...style.cellStyle, width: column.width }}>
              <div id={deleteBtnId}>
                <Button
                  size="sm"
                  disabled={
                    isUpdating || (CountOfCandidates && CountOfCandidates > 0)
                      ? true
                      : false /*|| row.CannotBeUnlocked*/
                  }
                  color={CountOfCandidates && CountOfCandidates > 0 ? 'secondary' : 'danger'}
                  onClick={() => {
                    Swal.fire({
                      text: 'Are you sure you want to delete this interview date?',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#d33',
                      confirmButtonText: 'Yes, delete it!',
                    }).then((result) => {
                      if (result.value) {
                        deleteEntry(pk_InterviewDate);
                      }
                    });
                  }}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </Button>
              </div>

              {!hiddenParent && CountOfCandidates && CountOfCandidates > 0 ? (
                <UncontrolledTooltip target={deleteBtnId} placement={'top'}>
                  Unable to delete Interview dates with registered candidates!
                </UncontrolledTooltip>
              ) : (
                <span></span>
              )}
            </div>
          );
        case 'Visibility':
          return (
            <div style={{ ...style.cellStyle, width: column.width }}>
              <Button
                size="sm"
                id={`visibility_${pk_InterviewDate}`}
                disabled={isUpdating || CannotBeUnlocked}
                color={CannotBeUnlocked ? 'secondary' : EnableHiddenStatus ? 'danger' : 'success'}
                onClick={() => {
                  updateEntry({ EnableHiddenStatus: !EnableHiddenStatus }, pk_InterviewDate);
                }}
              >
                <FontAwesomeIcon icon={EnableHiddenStatus || CannotBeUnlocked ? faEyeSlash : faEye} />
              </Button>
              {!hiddenParent && CannotBeUnlocked ? (
                <UncontrolledTooltip target={`visibility_${pk_InterviewDate}`} placement={'top'}>
                  Session is in the past. You cannot modify hide status.
                </UncontrolledTooltip>
              ) : (
                <span></span>
              )}
            </div>
          );
        case 'Lock':
          return (
            <div style={{ ...style.cellStyle, width: column.width }}>
              <Button
                id={`lock_${pk_InterviewDate}`}
                disabled={isUpdating || CannotBeUnlocked}
                color={CannotBeUnlocked || EnableLockedStatus ? 'secondary' : EnableLockedStatus ? 'danger' : 'success'}
                onClick={() => {
                  updateEntry({ EnableLockedStatus: !EnableLockedStatus }, pk_InterviewDate);
                }}
              >
                <FontAwesomeIcon icon={EnableLockedStatus || CannotBeUnlocked ? faLock : faLockOpen} />
              </Button>
              {!hiddenParent && CannotBeUnlocked ? (
                <UncontrolledTooltip target={`lock_${pk_InterviewDate}`} placement={'top'}>
                  Session is in the past. You cannot modify hide/lock status.
                </UncontrolledTooltip>
              ) : (
                <span></span>
              )}
            </div>
          );
        case 'Candidates':
          return (
            <div style={{ ...style.cellStyle, width: column.width }}>
              <Button
                color="secondary"
                disabled={isUpdating}
                onClick={() => {
                  history.push(`/administrator/candidates/sendmessages?pk_InterviewDate=${pk_InterviewDate}`);
                }}
              >
                <FontAwesomeIcon icon={faUsers} />
              </Button>
            </div>
          );
        case 'settings_placeholder':
          return (
            <div style={{ ...style.cellStyle, width: column.width }}>
              <div id={`visibility_${pk_InterviewDate}_${hiddenParent ? 'hidden' : 'visible'}`}>
                <Button
                  size="sm"
                  disabled={isUpdating || CannotBeUnlocked || isPastInterviewDate}
                  color={
                    CannotBeUnlocked || isPastInterviewDate ? 'secondary' : EnableHiddenStatus ? 'danger' : 'success'
                  }
                  style={{ marginRight: 10 }}
                  onClick={() => {
                    updateEntry({ EnableHiddenStatus: !EnableHiddenStatus }, pk_InterviewDate);
                  }}
                >
                  <FontAwesomeIcon
                    icon={EnableHiddenStatus || CannotBeUnlocked || isPastInterviewDate ? faEyeSlash : faEye}
                  />
                </Button>
              </div>

              {!hiddenParent && (CannotBeUnlocked || isPastInterviewDate) ? (
                <UncontrolledTooltip
                  target={`visibility_${pk_InterviewDate}_${hiddenParent ? 'hidden' : 'visible'}`}
                  placement={'top'}
                >
                  Session {isPastInterviewDate ? `is in the past` : ' cannot be unlocked'}. You cannot modify its hide
                  status.
                </UncontrolledTooltip>
              ) : (
                <span></span>
              )}

              <div id={`lock_${pk_InterviewDate}_${hiddenParent ? 'hidden' : 'visible'}`}>
                <Button
                  size="sm"
                  disabled={isUpdating || CannotBeUnlocked || isPastInterviewDate}
                  color={
                    CannotBeUnlocked || EnableLockedStatus || isPastInterviewDate
                      ? // ? 'secondary'
                        // : EnableLockedStatus
                        'danger'
                      : 'success'
                  }
                  style={{ marginRight: 10 }}
                  onClick={() => {
                    updateEntry({ EnableLockedStatus: !EnableLockedStatus }, pk_InterviewDate);
                  }}
                >
                  <FontAwesomeIcon
                    icon={EnableLockedStatus || CannotBeUnlocked || isPastInterviewDate ? faLock : faLockOpen}
                  />
                </Button>
              </div>

              {!hiddenParent && (CannotBeUnlocked || isPastInterviewDate) ? (
                <UncontrolledTooltip
                  target={`lock_${pk_InterviewDate}_${hiddenParent ? 'hidden' : 'visible'}`}
                  placement={'top'}
                >
                  Session {isPastInterviewDate ? `is in the past` : ' cannot be unlocked'}. You cannot modify its lock
                  status.
                </UncontrolledTooltip>
              ) : (
                <span></span>
              )}

              <LinkSettingsButton
                id={`settings_btn_${rowIndex}_${hiddenParent ? 'hidden' : 'visible'}`}
                // btnSize={'lg'}
                hiddenParent={hiddenParent}
                marginRight={0}
                MainRoomURL={MainRoomURL}
                MainRoomURLDetails={MainRoomURLDetails}
                scheduleDate={MomentDateOfInterview}
                scheduleData={cellData}
                scheduleID={pk_InterviewDate}
                dContext={dContext}
                btnWidth={34}
                onUpdate={getActiveInterviewDates}
              />
              {/* <Button color="secondary" id={`settings_btn_${rowIndex}`} disabled={isUpdating}>
                <FontAwesomeIcon icon={faCog} />
              </Button> */}
              {/* {renderSettingsPopOver({ ...row, rowIndex })} */}
            </div>
          );
        case 'schedule_placeholder':
          return (
            <div style={{ ...style.cellStyle, width: column.width }}>
              <Button
                id={`calendar_${pk_InterviewDate}`}
                size="sm"
                disabled={isUpdating}
                color={ScheduleBuildingHasBeenStarted ? 'success' : 'secondary'}
                onClick={() => {
                  handleScheduleClick(pk_InterviewDate);
                }}
              >
                <FontAwesomeIcon icon={faCalendarAlt} />
              </Button>
              <UncontrolledTooltip target={`calendar_${pk_InterviewDate}`} placement={'top'}>
                {ScheduleBuildingHasBeenStarted ? 'Modify Schedule' : 'Start Building Schedule'}
              </UncontrolledTooltip>
            </div>
          );

        case 'CandidateRegistrationLimit':
          return renderLimitInput({ cell, cellData, rowIndex, formatExtraData, renderType: 2 });
        case 'print_materials_placeholder':
          const key = `printer_btn_${rowIndex}_${hiddenParent ? 'hidden' : 'visible'}`;
          return (
            <div style={{ ...style.cellStyle, width: column.width }}>
              <Button
                size="sm"
                disabled={isUpdating}
                id={key}
                onClick={() => {
                  setPrintPopoverOpen(key, !showSettings[key]);
                }}
              >
                <FontAwesomeIcon icon={faPrint} />
              </Button>
              {renderPrintPopover({ ...cellData, rowIndex, targetId: key })}
            </div>
          );

        case 'MomentDateOfInterview':
          const dateInputKey = `date_popover_${pk_InterviewDate}_${dayjs(cell).format('MMM_DD_YYYY')}`;

          return (
            <div style={{ ...style.cellStyle, width: column.width }}>
              <div style={style.simpleColumn}>
                <div style={style.simpleRow}>
                  <InputGroup>
                    <Input
                      id={dateInputKey}
                      key={`${dateInputKey}_${Label ? Label.replace(/[^a-zA-Z0-9]/g, '') : ''}`}
                      type={Label ? 'textarea' : 'text'}
                      rows={2}
                      onFocus={(e) => {
                        e.target.blur();
                      }}
                      defaultValue={`${dayjs(cell).format('MMM. DD, YYYY (ddd)')} \n${Label || ' '}`}
                      style={{
                        textAlign: 'left',
                        height: Label ? null : 52,
                        flexWrap: 'wrap',
                        resize: 'none',
                        fontSize: 13,
                      }}
                      onClick={(e) => {
                        e.target.blur();

                        toggleModal(dateInputKey);
                      }}
                    />
                    <Button
                      size="sm"
                      style={{ zIndex: 0 }}
                      color="secondary"
                      onClick={() => {
                        toggleModal(dateInputKey);
                        setOpenPicker(false);
                      }}
                    >
                      <FontAwesomeIcon icon={faPencilAlt} />
                    </Button>
                  </InputGroup>
                  {renderDatePopover({ ...cellData, rowIndex, cell, dateInputKey })}
                </div>
                {/* <div style={style.simpleRow}>
                  <div style={style.centeredText}>{row.Label}</div>
                </div> */}
              </div>
            </div>
          );
        case 'CountOfCandidates':
          return (
            <div style={{ ...style.cellStyle, width: column.width, fontWeight: 'bold' }}>
              <div
                style={{ cursor: 'pointer', color: '#007bff' }}
                onClick={() => {
                  history.push(`/administrator/candidates/sendmessages?pk_InterviewDate=${pk_InterviewDate}`);
                }}
              >
                {cell ? cell : 0}
              </div>
            </div>
          );
        case 'NumberOfWaitlistedCandidates':
          return (
            <div style={{ ...style.cellStyle, fontWeight: 'bold' }}>
              <div
                style={{ cursor: 'pointer', color: '#007bff' }}
                onClick={() => {
                  history.push(`/administrator/communications/waitlist?pk_InterviewDate=${pk_InterviewDate}`);
                }}
              >
                {cell || 0}
              </div>
            </div>
          );
        default:
          return <div style={{ ...style.cellStyle, width: column.width }}> {cell || ''}</div>;
      }
    }

    // }
  };

  const handleLockDates = (pk_InterviewDate) => {
    setIsUpdatingLockBeforeDays(true);

    getTokenSilently()
      .then((token) => {
        putData(
          `/InterviewDate/LockDate`,
          null,
          {
            LockBeforeDays: lockBeforeDays,
            pk_InterviewDate: pk_InterviewDate,
          },
          formatBearerToken(token),
        )
          .then((response) => {
            setIsUpdatingLockBeforeDays(false);
            if (checkLoginForError(response.data)) {
              toast.success('Lock date updated successfully!');
              getActiveInterviewDates();
            }
          })
          .catch((error) => {
            setIsUpdatingLockBeforeDays(false);
            if (checkLoginForError(error.response?.data)) {
              toast.error('Error updating lock date');
            }
          });
      })
      .catch((err) => {
        setIsUpdatingLockBeforeDays(false);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const makeColumns = () => {
    const headers = [
      { text: 'Delete', dataField: 'delete_placeholder', minWidth: 100 },
      { text: 'Interview Sessions', dataField: 'MomentDateOfInterview', minWidth: 250 },
      { text: 'Registered', dataField: 'CountOfCandidates', minWidth: 120 },
      { text: 'Waitlisted', dataField: 'NumberOfWaitlistedCandidates', minWidth: 120 },
      { text: 'Limit', dataField: 'CandidateRegistrationLimit', minWidth: 100 },
      // { text: 'Visibility', dataField: 'EnableHiddenStatus' },
      // { text: 'Lock', dataField: 'EnableLockedStatus' },
      { text: 'Settings', dataField: 'settings_placeholder', minWidth: 170 },
      // { text: 'Candidates', dataField: 'candidates_placeholder' },
      { text: 'Print Materials', dataField: 'print_materials_placeholder', minWidth: 140 },
      { text: 'Schedule', dataField: 'schedule_placeholder', minWidth: 100 },
    ];
    const newColumns = [];

    headers.forEach((header) => {
      const { minWidth } = header;

      newColumns.push({
        dataKey: header.dataField,
        text: header.text,
        label: header.text,
        formatter: cellFormatter,
        headerFormatter: headerFormatter,
        // classes: 'timeSlot',
        style: (cell, row, rowIndex, colIndex) => {
          return {
            verticalAlign: 'middle',
            padding: rowIndex < filteredInterviewDates.length - 1 ? 0 : 5,
            cursor: header.dataField === 'CountOfCandidates' ? 'pointer' : 'normal',
          };
        },
        headerStyle: {
          top: -2,
          position: 'sticky',
          verticalAlign: 'middle',
          backgroundColor: 'white',
          zIndex: 3,
          padding: 20,
          minWidth,
          width: minWidth,
        },
        // isTime: true,
        formatExtraData: { label: header.text },
        events: {
          onClick: (e, column, columnIndex, row, rowIndex) => {},
        },
        headerEvents: {
          onClick: (e, column, columnIndex) => {},
        },
        headerAttrs: {
          // id: 'timeSlotHeader',
        },
        attrs: (cell, row, rowIndex, colIndex) => {
          // return { id: `timeSlot_${row.pk_Timeslot}` };
        },
      });
    });

    return newColumns;
  };

  const renderDatePopover = (row) => {
    const { CountOfCandidates, pk_InterviewDate, dateInputKey } = row;
    const key = dateInputKey;

    return (
      <Popover
        flip={false}
        popperClassName=""
        isOpen={showSettings[key]}
        target={key}
        trigger="click"
        toggle={() => {
          const newSettings = clone(showSettings);
          if (newSettings[key]) {
            newSettings[key] = !newSettings[key];
            setShowSettings(newSettings);
          }
        }}
      >
        <PopoverHeader>
          <div style={style.popOverHeader}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              Interview Date
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();
                  setPrintPopoverOpen(key, false);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody style={style.popOverBody}>
          <InterviewDatePopover
            setShowPopover={(newValue) => {
              const newSettings = clone(showSettings);
              newSettings[key] = newValue;
              setShowSettings(newSettings);
            }}
            onUpdate={() => {
              toast.success('Interview Date updated!');
              getActiveInterviewDates();
              const newSettings = clone(showSettings);
              if (newSettings[key]) {
                newSettings[key] = !newSettings[key];
                setShowSettings(newSettings);
              }
            }}
            interviewDate={row}
            token={token}
            dContext={dContext}
            CountOfCandidates={CountOfCandidates}
          />
        </PopoverBody>
      </Popover>
    );
  };

  const renderHeaderDatePopover = () => {
    return (
      <Popover
        flip={true}
        placement="right-start"
        modifiers={[
          {
            name: 'flip',
            options: {
              fallbackPlacements: ['left-start', 'bottom-start', 'top-start'],
            },
          },
        ]}
        popperClassName=""
        isOpen={openPicker}
        target={'addInterviewDateBtn'}
        trigger="legacy"
        onOpen={() => {
          setTimeout(() => {
            document.getElementById('date_btn_undefined_actual').click();
          }, 1000);
        }}
        toggle={() => {}}
      >
        <PopoverHeader>
          <div style={style.popOverHeader}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              Add Interview Session
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenPicker(false);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody style={style.popOverBody}>
          <InterviewDatePopover
            setShowPopover={(newValue) => {
              setOpenPicker(newValue);
            }}
            onAdd={(date) => {
              addDate(date);
            }}
            token={token}
            dContext={dContext}
          />
        </PopoverBody>
      </Popover>
    );
  };

  const renderRegistrationLimitPopover = (row) => {
    const { targetId } = row;

    const key = targetId;
    return (
      <Popover
        flip={false}
        placementPrefix="registrationLimitsPopover bs-popover"
        isOpen={showSettings[key]}
        target={key}
        trigger="legacy"
        toggle={(e) => {
          if (e.target.className.includes && e.target.className.includes('swal2')) {
            return;
          }
          if (tagFilterHasChanges) {
            e.stopPropagation();
            e.preventDefault();
            Swal.fire({
              closeOnClickOutside: false,
              text:
                'You have unsaved changes in the Tag Filter. Please save or discard your changes before continuing.',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Discard Changes',
              cancelButtonText: 'Cancel',
            }).then((result) => {
              if (result.value) {
                const newSettings = clone(showSettings);
                newSettings[key] = false;
                setShowSettings(newSettings);

                setTagFilterHasChanges(false);
                // const newSettings = clone(showSettings);
                // newSettings[key] = !newSettings[key];
                // setShowSettings(newSettings);
              } else {
                return;
              }
            });
            return;
          }

          if (e.target.id !== 'infoBody1' && e.target.id !== 'infoBody2' && e.target.id !== 'infoHeader') {
            const newSettings = clone(showSettings);
            newSettings[key] = !newSettings[key];
            setShowSettings(newSettings);
          }
        }}
      >
        <PopoverHeader>
          <div style={style.popOverHeader}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              {/* {row.MomentDateOfInterview.format('MMM DD, YYYY')}{' '} */}
              Limit Session Visibility by Tag
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();
                  const newSettings = clone(showSettings);
                  newSettings[key] = !newSettings[key];
                  setShowSettings(newSettings);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody style={style.popOverBody}>
          <div>
            <RegistrationLimitPopover
              setShowSettings={(value) => {
                const newSettings = clone(showSettings);
                newSettings[key] = value;
                setShowSettings(newSettings);
              }}
              getActiveInterviewDates={getActiveInterviewDates}
              isUpdating={isUpdating}
              updateEntry={updateEntry}
              tags={tagChoices}
              data={row}
              token={token}
              dContext={dContext}
              setTagFilterHasChanges={setTagFilterHasChanges}
            />
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  const renderPrintPopover = (row) => {
    const { targetId } = row;

    const key = targetId; //`printer_btn_${row.rowIndex}`;

    return (
      <Popover
        flip={false} // popperClassName="adminPrintPopover"
        placementPrefix="adminPrintPopover bs-popover"
        isOpen={showSettings[key]}
        target={targetId}
        trigger="legacy"
        placement="left"
        toggle={(e) => {
          // if (e.target.id == key) {
          //   const newSettings = clone(showPrinter);
          //   Object.keys((oldKey) => {
          //     if (oldKey === key) {
          //       newSettings[key] = !showPrinter[key];
          //     } else {
          //       newSettings[key] = false;
          //     }
          //   });
          //   setShowSettings(newSettings);
          //   showPrinter[key] = !showPrinter[key];
          // }
        }}
      >
        <PopoverHeader>
          <div style={style.popOverHeader}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              Print Materials for {dayjs(row.MomentDateOfInterview).format('MMM DD, YYYY')}{' '}
              {row.Label ? `(${row.Label})` : ''}
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();
                  const newSettings = clone(showSettings);
                  newSettings[key] = !newSettings[key];
                  setShowSettings(newSettings);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody>
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <PrintDropDown
              row={row}
              isScheduleInitialized={row.ScheduleBuildingHasBeenStarted}
              setShowSettings={(value) => {
                setPrintPopoverOpen(key, value);
              }}
            />
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  const renderPrintAllPopover = () => {
    const key = 'printer_all_btn';

    return (
      <Popover
        flip={false}
        placementPrefix="adminPrintPopover bs-popover"
        isOpen={showSettings[key]}
        target={key}
        trigger="legacy"
        placement="left"
        toggle={() => {}}
      >
        <PopoverHeader>
          <div style={style.popOverHeader}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              Print Materials for All Candidates
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();
                  setPrintPopoverOpen(key, false);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody>
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <PrintDropDownTotal
              setShowSettings={(value) => {
                setPrintPopoverOpen(key, value);
              }}
            />
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  const getSessionDateKey = (session) => {
    const baseDate = session.DateOfInterview || session.MomentDateOfInterview;
    if (!baseDate) {
      return null;
    }
    return dayjs(baseDate).format('YYYY-MM-DD');
  };

  const renderCalendarSessionActions = (session) => {
    const {
      pk_InterviewDate,
      CountOfCandidates,
      NumberOfWaitlistedCandidates,
      CandidateRegistrationLimit,
      EnableHiddenStatus,
      EnableLockedStatus,
      CannotBeUnlocked,
      ScheduleBuildingHasBeenStarted,
      MainRoomURL,
      MainRoomURLDetails,
      MomentDateOfInterview,
      DateOfInterview,
      StartTime,
    } = session;

    const rowIndex = `calendar_${pk_InterviewDate}`;
    const hiddenParent = false;

    const dateInThisTimeZone = dayjs
      .tz(`${DateOfInterview} ${StartTime}`, departmentSettings.TimeZone)
      .tz(dayjs.tz.guess());
    const dateToCompare = dayjs(`${dateInThisTimeZone.format('MMM DD,  YYYY')} 23:59`);
    const isPastInterviewDate = !dateToCompare.isSameOrAfter(today, 'day');

    const printKey = `printer_btn_${rowIndex}_${hiddenParent}`;

    return (
      <div style={{ marginTop: 8, borderTop: '1px solid #e5e7eb', paddingTop: 8 }}>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
          <div style={{ fontSize: 12 }}>
            Registered:{' '}
            <span
              style={{ cursor: 'pointer', color: '#007bff', fontWeight: 'bold' }}
              onClick={() => {
                history.push(`/administrator/candidates/sendmessages?pk_InterviewDate=${pk_InterviewDate}`);
              }}
            >
              {CountOfCandidates || 0}
            </span>
          </div>
          <div style={{ fontSize: 12 }}>
            Waitlisted:{' '}
            <span
              style={{ cursor: 'pointer', color: '#007bff', fontWeight: 'bold' }}
              onClick={() => {
                history.push(`/administrator/communications/waitlist?pk_InterviewDate=${pk_InterviewDate}`);
              }}
            >
              {NumberOfWaitlistedCandidates || 0}
            </span>
          </div>
          <div style={{ width: '100%', flexBasis: '100%', minWidth: 0 }}>
            {renderLimitInput({
              cell: CandidateRegistrationLimit,
              cellData: { ...session, rowIndex, hiddenParent },
              rowIndex,
              renderType: 2,
            })}
          </div>
          <Button
            size="sm"
            id={`visibility_${pk_InterviewDate}_${hiddenParent}`}
            disabled={isUpdating || CannotBeUnlocked || isPastInterviewDate}
            color={CannotBeUnlocked || isPastInterviewDate || EnableHiddenStatus ? 'danger' : 'success'}
            onClick={() => {
              updateEntry({ EnableHiddenStatus: !EnableHiddenStatus }, pk_InterviewDate);
            }}
          >
            <FontAwesomeIcon icon={EnableHiddenStatus || CannotBeUnlocked || isPastInterviewDate ? faEyeSlash : faEye} />
          </Button>
          <Button
            size="sm"
            id={`lock_${pk_InterviewDate}_${hiddenParent}`}
            disabled={isUpdating || CannotBeUnlocked || isPastInterviewDate}
            color={CannotBeUnlocked || EnableLockedStatus || isPastInterviewDate ? 'danger' : 'success'}
            onClick={() => {
              updateEntry({ EnableLockedStatus: !EnableLockedStatus }, pk_InterviewDate);
            }}
          >
            <FontAwesomeIcon icon={EnableLockedStatus || CannotBeUnlocked || isPastInterviewDate ? faLock : faLockOpen} />
          </Button>
          <LinkSettingsButton
            id={`settings_btn_${rowIndex}_${hiddenParent}`}
            hiddenParent={hiddenParent}
            marginRight={0}
            MainRoomURL={MainRoomURL}
            MainRoomURLDetails={MainRoomURLDetails}
            scheduleDate={MomentDateOfInterview}
            scheduleData={session}
            scheduleID={pk_InterviewDate}
            dContext={dContext}
            btnWidth={34}
            onUpdate={getActiveInterviewDates}
          />
          <Button
            size="sm"
            disabled={isUpdating}
            id={printKey}
            onClick={() => {
              setPrintPopoverOpen(printKey, !showSettings[printKey]);
            }}
          >
            <FontAwesomeIcon icon={faPrint} />
          </Button>
          {renderPrintPopover({ ...session, rowIndex, targetId: printKey })}
          <Button
            id={`calendar_${pk_InterviewDate}_${hiddenParent}`}
            size="sm"
            disabled={isUpdating}
            color={ScheduleBuildingHasBeenStarted ? 'success' : 'secondary'}
            onClick={() => {
              handleScheduleClick(pk_InterviewDate);
            }}
          >
            <FontAwesomeIcon icon={faCalendarAlt} />
          </Button>
          <UncontrolledTooltip target={`calendar_${pk_InterviewDate}_${hiddenParent}`} placement={'top'}>
            {ScheduleBuildingHasBeenStarted ? 'Modify Schedule' : 'Start Building Schedule'}
          </UncontrolledTooltip>
        </div>
      </div>
    );
  };

  const renderCalendarView = () => {
    const sessions = filteredInterviewDates.filter((d) => d.pk_InterviewDate !== 'summary_row');
    const sessionsInCalendarMonth = sessions.filter((session) => {
      const dateKey = getSessionDateKey(session);
      if (!dateKey) {
        return false;
      }
      const sessionDay = dayjs(dateKey);
      return sessionDay.month() === calendarMonth.month() && sessionDay.year() === calendarMonth.year();
    });
    const hasSessionsInMonth = sessionsInCalendarMonth.length > 0;
    const startOfMonth = calendarMonth.startOf('month');
    const endOfMonth = calendarMonth.endOf('month');
    const gridStart = startOfMonth.startOf('week');
    const gridEnd = endOfMonth.endOf('week');

    const sessionsByDate = sessions.reduce((acc, session) => {
      const key = getSessionDateKey(session);
      if (!key) {
        return acc;
      }
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(session);
      return acc;
    }, {});

    const calendarDays = [];
    let cursor = gridStart;
    while (cursor.isBefore(gridEnd) || cursor.isSame(gridEnd, 'day')) {
      calendarDays.push(cursor);
      cursor = cursor.add(1, 'day');
    }

    const openMonthPicker = () => {
      const picker = monthPickerRef.current;
      if (!picker) {
        return;
      }

      if (typeof picker.showPicker === 'function') {
        try {
          picker.showPicker();
        } catch (err) {
          // Ignore browsers that block picker opening outside accepted user gestures.
        }
      }
    };

    return (
      <div
        style={{
          height: `calc(100vh - 315px)`,
          border: '1px solid #dee2e6',
          borderRadius: 6,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'white',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 12,
            flexShrink: 0,
            borderBottom: '1px solid #e5e7eb',
            backgroundColor: 'white',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              width: 250,
              flexShrink: 0,
              justifyContent: 'space-between',
            }}
          >
            <Button size="sm" color="secondary" onClick={() => setCalendarMonth(calendarMonth.subtract(1, 'month'))}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </Button>
            <Input
              innerRef={monthPickerRef}
              type="month"
              value={calendarMonth.format('YYYY-MM')}
              style={{ width: 150, textAlign: 'center' }}
              onClick={openMonthPicker}
              onChange={(e) => {
                const newValue = e.target.value;
                if (!newValue) {
                  return;
                }
                setCalendarMonth(dayjs(`${newValue}-01`).startOf('month'));
              }}
            />
            <Button size="sm" color="secondary" onClick={() => setCalendarMonth(calendarMonth.add(1, 'month'))}>
              <FontAwesomeIcon icon={faChevronRight} />
            </Button>
          </div>
          <div style={{ flex: 1, margin: '0 12px', maxWidth: 340 }}>
            <RezRateBanner
              message={hasSessionsInMonth ? 'Sessions Found' : 'No Sessions Found'}
              backgroundColor={hasSessionsInMonth ? '#38d662' : '#e81300'}
            />
          </div>
          <div>
            <Button
              color="success"
              size="sm"
              id={'addInterviewDateBtn'}
              onClick={() => {
                setOpenPicker(!openPicker);
                const newSettings = clone(showSettings);
                Object.keys(newSettings).forEach((key) => {
                  newSettings[key] = false;
                });
                setShowSettings(clone(newSettings));
              }}
            >
              Add Session
            </Button>
            {renderHeaderDatePopover()}
          </div>
        </div>
        <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(7, minmax(180px, 1fr))',
              gap: 8,
              padding: 12,
            }}
          >
            {calendarDays.map((day) => {
              const dayKey = day.format('YYYY-MM-DD');
              const daySessions = sessionsByDate[dayKey] || [];
              const isCurrentMonth = day.month() === calendarMonth.month();
              return (
                <div
                  key={dayKey}
                  style={{
                    minHeight: 140,
                    border: '1px solid #e5e7eb',
                    borderRadius: 6,
                    padding: 8,
                    backgroundColor: isCurrentMonth ? 'white' : '#f8f9fa',
                    opacity: isCurrentMonth ? 1 : 0.7,
                  }}
                >
                  <div style={{ fontSize: 12, fontWeight: 'bold', marginBottom: 6 }}>
                    {day.format('ddd, MMM D')}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    {daySessions.map((session) => {
                      const dateInThisTimeZone = dayjs
                        .tz(`${session.DateOfInterview} ${session.StartTime}`, departmentSettings.TimeZone)
                        .tz(dayjs.tz.guess());
                      const sessionKey = `${session.pk_InterviewDate}_calendar`;
                      const isExpanded = expandedSessionKey === sessionKey;

                      return (
                        <Card key={sessionKey} style={{ margin: 0 }}>
                          <CardBody style={{ padding: 8 }}>
                            <div
                              style={{ cursor: 'pointer', fontSize: 12, fontWeight: 600 }}
                              onClick={() => {
                                setExpandedSessionKey(isExpanded ? null : sessionKey);
                              }}
                            >
                              {dateInThisTimeZone.format('h:mm A')} {session.Label ? `- ${session.Label}` : ''}
                            </div>
                            {isExpanded ? renderCalendarSessionActions(session) : null}
                          </CardBody>
                        </Card>
                      );
                    })}
                    {daySessions.length === 0 ? <div style={{ fontSize: 11, color: '#9ca3af' }}>No sessions</div> : null}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  const { EnableAutoSlotState } = departmentSettings || {};

  return (
    <div>
      <div style={{ ...style.hideInterviewDatesContainer }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <FormGroup switch>
              <Input
                type="checkbox"
                role="switch"
                id="hidePast"
                name="hidePast"
                checked={showPastInterviewDates == 'false' ? false : true}
                onChange={() => {
                  const newValue = showPastInterviewDates == 'true' ? 'false' : 'true';
                  setCookies('showPastInterviewDates', newValue, { path: '/' });
                  setShowPastInterviewDates(newValue);
                  filterInterviewDates();
                }}
              />
              <Label htmlFor="hidePast">Show past Interview dates</Label>
            </FormGroup>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginLeft: 'auto' }}>
          <div
            id="autoRegistration_info"
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontStyle: 'italic' }}
          >
            <span>
              Auto Registration is:{' '}
              <span
                style={{
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  color: EnableAutoSlotState === undefined ? null : EnableAutoSlotState ? 'green' : 'red',
                }}
                onClick={() => {
                  history.push('/administrator/settings/communication');
                }}
              >
                {EnableAutoSlotState === undefined ? '----' : EnableAutoSlotState ? 'Enabled' : 'Disabled'}
              </span>{' '}
            </span>
            {EnableAutoSlotState != null ? (
              <UncontrolledTooltip target="autoRegistration_info">
                {EnableAutoSlotState
                  ? 'Candidates will automatically register for interview sessions.'
                  : 'Candidates will not automatically register for interview sessions.'}
              </UncontrolledTooltip>
            ) : null}
          </div>
          <Button
            color="secondary"
            size="sm"
            onClick={() => {
              const nextIsCalendarView = !isCalendarView;
              persistAltViewPreference(nextIsCalendarView);
              setIsCalendarView(nextIsCalendarView);
              setExpandedSessionKey(null);
            }}
          >
            <FontAwesomeIcon icon={isCalendarView ? faList : faCalendarDays} style={{ marginRight: 6 }} />
            {isCalendarView ? 'Table View' : 'Calendar View'}
          </Button>
        </div>
      </div>
      {isCalendarView ? (
        renderCalendarView()
      ) : (
        <div style={{ height: `calc(100vh - 315px)` }}>
          <RezRateTable
            columns={makeColumns()}
            data={filteredInterviewDates}
            tableBodyHeight={`calc(100vh - 345px)`}
            tableType="striped"
            rowStyle={(row, rowIndex) => {
              if (rowIndex >= filteredInterviewDates.length - 1 || filteredInterviewDates.length == 1) {
                return { position: 'sticky', bottom: -2, backgroundColor: 'white' };
              }
            }}
          />
        </div>
      )}

      {/* {renderSummaryFooter()} */}
    </div>
  );
};

// add filter days in the past
// add locked button if dates past
// if it's hidden show it as red locked

export default withCookies(AdminInterviewDates);
